import React from 'react'
import PropTypes from 'prop-types'
import Mobile from './Mobile'

import './index.css'

class Layout extends React.Component {
  state = {
    collapsed: true,
  }

  toggleCollapse = () => {
    const collapsed = !this.state.collapsed
    this.setState({collapsed})
  }

  render() {
    const {children, ...props} = this.props

    // Always render mobile for now, as we have not yet implemented
    // any design for desktop.
    return (
      <Mobile
        {...props}
        collapsed={this.state.collapsed}
        toggleCollapse={this.toggleCollapse}
      >
        {children}
      </Mobile>
    )
  }
}

Layout.propTypes = {
  location: PropTypes.object.isRequired,
  title: PropTypes.string,
  backLink: PropTypes.string,
}

export default Layout
